import React, { useEffect, useRef } from "react";


import scrollToDomElement from "@Utilities/Scrolling";


import {
    Navigate
} from "react-router-dom";

import {
    Row, Col
} from "react-bootstrap";


import {
    ButtonComponent
} from "@Components/Forms";


import MainImage from "./@Images/summary-image.svg";
import IconHomeSmBrown from "./@Icons/icon-home-sm-brown.svg";


import "./index.scss";


export const UserDashboardSubmitRequestFinalStepComponent:React.FC = () => {


    const finalStepContentRef = useRef(null);

    useEffect(() => {
        if (finalStepContentRef?.current) {
            scrollToDomElement(finalStepContentRef.current, 200);
        }
    }, []);


    const [goToHomePageTrigger, setGoToHomePageTrigger] = React.useState(false);

    useEffect(() => {
        return () => {
            setGoToHomePageTrigger(false);
        };
    }, []);


    if (goToHomePageTrigger) {
        return <Navigate to={'/sign-in'} replace />;
    }


    return (
        <Col xs={12} ref={finalStepContentRef} className={`user-dashboard-submit-request-final-step`}>
            <Row className={`user-dashboard-submit-request-final-step__step-content`}>

                <Col xs={12} className={`user-dashboard-submit-request-final-step__step-image`}>
                    <img src={MainImage} alt={''} />
                </Col>

                <Col xs={12} className={`user-dashboard-submit-request-final-step__step-header`}>
                    <span>Your refund request has been sent!</span>
                </Col>

                <Col xs={12} className={`user-dashboard-submit-request-final-step__step-description`}>
                    <span>Your claim is now being processed.</span>
                    <span>We'll update you as soon as the airline responds.</span>
                </Col>

                <Col xs={12} className={`user-dashboard-submit-request-final-step__step-buttons`}>
                    <ButtonComponent
                        text={'Go Home'} iconLeft={IconHomeSmBrown}
                        callback={() => setGoToHomePageTrigger(true)}
                    />
                </Col>

            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestFinalStepComponent;
